import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_djgzg75ijy: FaireBrandEntity = {
  token: "b_djgzg75ijy",
  type: "brand",
  name: "Open The Joy",
  avatarUrl:
    "https://cdn.faire.com/fastly/6df253e7d87c73991d5aed1d85500c2ebbc4980ecc0e322a3f1f11d07f063b5d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d1344cf758c22696091de33c6ee7c1d6cc61f76ca4f2e0a5fd9ed7e5a455e07b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6df253e7d87c73991d5aed1d85500c2ebbc4980ecc0e322a3f1f11d07f063b5d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d1344cf758c22696091de33c6ee7c1d6cc61f76ca4f2e0a5fd9ed7e5a455e07b.jpeg",
  location: "Princeton, NJ, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 25,
  isInsider: true,
  description:
    'Welcome to Open the Joy! Our focus is playQ: developing emotional intelligence in kids through play.\n\nHow do we do this? We make screen free activity kits, designed by therapists, with the intention of bonding families and fostering life skills in kids. Our award-winning kits have found fun and innovative ways of teaching important skills such as forgiveness, empathy and self-confidence, all through hands on fun!\n\nAll materials required to complete your EQ building activities come in the kit. Simply "Open the Joy" today, and help build an emotionally balanced tomorrow. Partner with us in our mission to "Grow Good Humans", one kit at a time.\n\nWHAT YOU CAN EXPECT FROM OPEN THE JOY:  \n\n✓Create a stronger bond with your family\n✓Develop motor skills with hands on activities\n✓Build confidence in your child through problem solving\n✓Therapeutic benefits to your child through play\n\nOUR GIVE BACK: \n\nSo that we never forget where we came from, Open the Joy partners with Spread The Joy (501)(c)3 in the free distribution of activity kits to hospitalized children across America. Find out more at: www.spreadthejoy.org\n\nYOU PLAY. WE GIVE. KIDS HEAL.',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:23.176Z",
    importedBy: "entity-db-cli",
  },
};
